export const faqs = [
  {
    question: '什么是磁力链？它和普通下载链接有什么区别？',
    answer: '磁力链（Magnet Link）是一种基于文件内容哈希值的P2P下载协议。与普通HTTP/FTP直接下载链接不同，磁力链不需要文件存储在单一服务器上，而是通过去中心化的P2P网络从多个节点同时获取数据。这使得磁力链具有更高的可用性和抗封锁能力。',
  },
  {
    question: '使用磁力链下载需要安装什么软件？',
    answer: '你需要安装支持磁力链协议的BT下载客户端。推荐使用qBittorrent（免费开源、功能全面）、Transmission（轻量级、适合NAS和老旧设备）、Deluge（高度可定制）等。安装完成后，系统会自动关联magnet:协议，点击磁力链即可开始下载。',
  },
  {
    question: '磁力链下载速度很慢怎么办？',
    answer: '下载速度慢的主要原因包括：资源做种人数少、网络端口未开放、ISP限速等。解决方案：添加更多Tracker服务器、启用DHT和PEX协议、检查防火墙设置、使用VPN绕过ISP限制、选择做种数更多的磁力链资源。',
  },
  {
    question: '磁力链和BT种子有什么区别？',
    answer: '磁力链是一条文本链接（如 magnet:?xt=urn:btih:...），而BT种子是一个 .torrent 文件。磁力链不需要提前下载种子文件，可以直接通过DHT网络发现资源节点，去中心化程度更高。两者底层使用相同的BitTorrent协议，下载体验基本一致。',
  },
  {
    question: '磁力链无法解析是什么原因？',
    answer: '常见原因包括：磁力链格式不完整、系统未关联magnet协议、客户端未运行、防火墙拦截。解决方法：检查链接完整性、手动复制到客户端、重新安装客户端修复协议关联、检查防火墙和杀毒软件设置。',
  },
  {
    question: '如何将磁力链转换为BT种子文件？',
    answer: '大多数BT客户端（如qBittorrent）在添加磁力链下载后，会自动生成对应的.torrent文件。你也可以在客户端中右键点击任务找到导出选项。此外，也有在线转换工具和命令行工具（如magnet2torrent）可以实现批量转换。',
  },
  {
    question: '使用磁力链是否需要VPN？',
    answer: '虽然不是必需的，但使用VPN可以保护你的网络隐私，防止ISP监控你的下载活动，同时也能绕过某些网络环境下的P2P限制。建议选择支持P2P流量、不记录日志的可靠VPN服务。',
  },
  {
    question: '如何判断磁力链资源是否安全？',
    answer: '检验资源安全性的方法：检查文件大小是否合理、查看社区评论和评分、验证文件扩展名是否与内容匹配、下载后用杀毒软件扫描、优先选择信誉良好的来源。避免下载可执行文件（.exe, .bat等）除非确认来源可靠。',
  },
];